<template>
    <b-container fluid class="p-0">
        <situacao-contrato :idContrato="ctr.IdContrato" />
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">{{ tituloPagina }}</span>
                    <btn-voltar />
                </h6>
            </template>
            <b-tabs v-model="abaAtiva" card>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" />
                        Dados iniciais
                    </template>
                    <aba-editar-dados-iniciais-contrato v-if="showForm && abaAtiva === 0" @atualizarContrato="atualizarContrato"
                        :ctr="ctr" />
                </b-tab>
                <b-tab v-if="isEdit" lazy>
                    <template #title>
                        <font-awesome-icon icon="address-card" class="mr-1 text-success" />
                        Contratados
                    </template>
                    <aba-editar-participantes-contrato :ctr="ctr"/>
                </b-tab>
                <b-tab v-if="isEdit" class="p-0" lazy>
                    <template #title>
                        <font-awesome-icon icon="hourglass-end" class="mr-1 text-secondary" />
                        Histórico
                    </template>
                    <detalhes-historico-contrato :idContrato="ctr.IdContrato" />
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import DetalhesHistoricoContrato from '@/components/licitacoes/contratos/DetalhesHistoricoContrato.vue'
import SituacaoContrato from '@/components/licitacoes/contratos/SituacaoContrato.vue'
import AbaEditarDadosIniciaisContrato from '@/components/licitacoes/contratos/editar-contrato/AbaEditarDadosIniciaisContrato.vue'
import AbaEditarParticipantesContrato from '@/components/licitacoes/contratos/editar-contrato/AbaEditarParticipantesContrato.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import contratoService from '@/services/licitacoes/contratoService'
import { store } from "@/store"
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'EditarContrato',
    components: {
        AbaEditarDadosIniciaisContrato, AbaEditarParticipantesContrato, DetalhesHistoricoContrato, 
        BtnVoltar, SituacaoContrato
    },
    props: {
        idContrato: {
            type: String,
            default: ''
        }
    },
})

@Component
export default class EditarContrato extends mixins(UtilsTS, CompProps) {
    ctr: Contrato = new Contrato()
    isEdit = false
    abaAtiva = 0 // qual aba está ativa no momento
    showForm = false

    get tituloPagina(): string {
        return `${this.isEdit ? 'Editar' : 'Criar'} Contrato/Ordem de Fornecimento ${this.isEdit ? this.ctr.NumeroAnoContrato : ''}`
    }

    get mostrarBtnSave(): boolean {
        return this.abaAtiva === 0
    }

    async mounted(): Promise<void> {
        try {
            store.blockScreen = true
            if (this.idContrato.length > 0) {
                this.isEdit = true
                this.ctr = await contratoService.buscarDadosGerais(this.idContrato)
                this.ctr.tratarDadosDaAPI()
            }
        }
        catch (e: unknown) {
            console.error('Erro ao abrir a edição de contratos', e)
        } finally {
            this.showForm = true
            store.blockScreen = false
        }
    }

    /**
     * Vamos tentar centralizar aqui as mudanças em flags de controle e no objeto principal 'contrato'
     * @param co nova instância de contrato, recém recebida da API
     */
    async atualizarContrato(co?: Contrato): Promise<void> {
        store.blockScreen = true
        try {
            if (!co) co = await contratoService.buscarDadosGerais(this.idContrato ?? this.ctr.IdContrato)
            this.ctr = Object.assign(new Contrato(), co)
            if (co.IdContrato > 0) this.isEdit = true
        } finally {
            store.blockScreen = false
        }
    }
}
</script>

<style></style>